import * as React from 'react'

import '../styles/Backdrop.scss'

export interface BackdropProps {
    show: boolean
    onClick?: (event: any) => void
    classes?: string
}

export class Backdrop extends React.Component<BackdropProps, {}> {

    constructor(props: any) {
        super(props)
    }

    onClick = (event: any) => {
        if (this.props.onClick) {
            this.props.onClick(event)
        }
    }

    render() {
        let className = 'backdrop'
        if (this.props.show) {
            className += ' active'
        }
        if (this.props.classes) {
            className += ' ' + this.props.classes
        }

        return (
            <div
                className={className}
                onClick={this.onClick}
            >
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Backdrop.tsx